export const PAGES = {
  HOME: 'Home',
  SUPPLIER: 'Suppliers',
  USERS: 'Users',
  TRIPS: 'Trips',
  PAYMENTS: 'Payments',
  BOOKINGS: 'Bookings',
  BOOKABLE_ACTIVITIES: 'Bookable',
  BOOKABLE: 'Bookable',
  ACTIVITIES: 'Activities',
  OUTREACH: 'Outreach',
  ANALYTICS: 'Analytics',
  TRIP_INSPIRATION: 'Trip Inspiration',
  NUDGES: 'Nudges',
}
